export function createReservationRequestId(
  now: () => number = Date.now,
  random: () => number = Math.random,
): string {
  const entropy = () => Math.floor(random() * 0x1_0000_0000)
    .toString(36)
    .padStart(7, '0');
  return `reservation_${now().toString(36)}_${entropy()}${entropy()}`;
}
